import { Action } from '@ngrx/store';
import { Credits } from '@usimweb/core/models';

export const LOAD_CREDITS = '[Contacts] Load Credits';
export const LOAD_CREDITS_FAIL = '[Contacts] Load Credits Fail';
export const LOAD_CREDITS_SUCCESS = '[Contacts] Load Credits Success';

export class LoadCredits implements Action {
  readonly type = LOAD_CREDITS;
}

export class LoadCreditsFail implements Action {
  readonly type = LOAD_CREDITS_FAIL;
  constructor(public payload: any) {}
}

export class LoadCreditsSuccess implements Action {
  readonly type = LOAD_CREDITS_SUCCESS;
  constructor(public payload: Credits) {}
}

export type CreditsActions = LoadCredits | LoadCreditsSuccess | LoadCreditsFail;
